import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { FormStrucItem } from '../../../../../../../lib/types/types';

import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
const P = Schema.attributes;

const AllgemeinAbschlussMesse: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Allgemein" description={PLATZHALTER_TEXT} />
			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte1()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default AllgemeinAbschlussMesse;

const formStrucSpalte1 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefoerderung_Name_Der_Messe,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefoerderung_Datum_Der_Messe,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefoerderung_Standflaeche_Messe,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpalte2 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0163728325_l_Gefuehrter_Messegespraeche,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0074782021_warteter_Vertragsabschluesse,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAllgemeinAbschlussMesse = () => {
	return concat(formStrucSpalte1(), formStrucSpalte2());
};
